module.exports = __webpack_public_path__ + "static/img/czy31.e7a5ecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/czy31.jpg
// module id = /l9k
// module chunks = 73